import { anyPass, allPass, defaultTo, find, pipe, propEq, values } from 'ramda';

export const getGame = maybeCode => pipe(
    values,
    find(allPass([
        anyPass([
            propEq('gameCode', maybeCode),
            propEq('seoFriendlyGameName', maybeCode)
        ])
    ])),
    defaultTo({})
);
